<div class="container">
  <div class="placeholder is-hidden-mobile"></div>
  <div class="columns is-tablet is-hidden-touch">
    <div class="column is-2"></div>
    <div class="column is-8">
      <div class="columns is-tablet">
        <div class="column"></div>
      </div>
    </div>
  </div>
  <div class="columns is-tablet is-gapless">
    <div class="column is-2"></div>
    <div class="column is-8">
      <ng-content></ng-content>
    </div>
    <div class="column is-2"></div>
  </div>
</div>
